module.exports = __webpack_public_path__ + "static/media/logo-full.78ae79b9.png";